import { render, staticRenderFns } from "./MyHealingPlan.vue?vue&type=template&id=020f5263&scoped=true&"
import script from "./MyHealingPlan.vue?vue&type=script&lang=js&"
export * from "./MyHealingPlan.vue?vue&type=script&lang=js&"
import style0 from "./MyHealingPlan.vue?vue&type=style&index=0&id=020f5263&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020f5263",
  null
  
)

export default component.exports